import axiosService from "./axios-service";

export const getRegions = async (region = "all") => {
  return axiosService.get(`/sales/incentive/fetch_region?region=${region}`);
};

export const addRegion = async (data) => {
  return axiosService.post(`/sales/incentive/upsert_region`, data);
};

export const uploadRegionFile = (data) => {
  return axiosService.post(`/sales/incentive/v2/upsert_region`, data);
};
